export default "__VITE_ASSET__VZjG$sgI__"